<template>
  <CreateScheduleModal
    :date="scheduleModalDate"
    :initial-client="getCurrentUpdateClient"
    :allow-date-selection="true"
  />

  <div class="modal fade update-client-modal" id="UpdateClientModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
          <div class="modal-content">
              <div class="modal-header">
                  <h1 class="modal-title fs-5">Cliente</h1>
                  <button type="button" class="btn-close update-client-modal" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>

              <div class="modal-body ps-30 pe-30 pb-0">
                <ul class="nav nav-tabs mb-4">
                  <li class="nav-item">
                    <button
                      type="button"
                      class="nav-link"
                      :class="{ active: activeTab === 'appointments' }"
                      @click="setActiveTab('appointments')"
                    >
                      Agendamentos
                    </button>
                  </li>
                  <li class="nav-item">
                    <button
                      type="button"
                      class="nav-link"
                      :class="{ active: activeTab === 'info' }"
                      @click="setActiveTab('info')"
                    >
                      Informações
                    </button>
                  </li>
                </ul>

                <div v-if="activeTab === 'appointments'">
                  <div class="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3 mb-20">
                    <button type="button" class="btn btn-primary" @click="openCreateScheduleModal">
                      Criar agendamento
                    </button>
                    <div>
                      <p class="mb-1 fw-medium">Histórico de agendamentos</p>
                      <p class="text-muted mb-0">Próximos e passados do cliente em uma única lista.</p>
                    </div>
                  </div>

                  <div class="table-responsive appointments-history-table-wrap">
                    <table class="table align-middle mb-0 appointments-history-table">
                      <thead>
                        <tr>
                          <th class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 ps-0">Data</th>
                          <th class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13">Horário</th>
                          <th class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13">Serviço</th>
                          <th class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13">Atendente</th>
                          <th class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pe-0">Valor</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="isLoadingAppointments">
                          <td colspan="5" class="text-center py-4 text-muted">Carregando agendamentos...</td>
                        </tr>
                        <tr v-else-if="appointments.length === 0">
                          <td colspan="5" class="text-center py-4 text-muted">Nenhum agendamento encontrado para este cliente.</td>
                        </tr>
                        <tr v-for="appointment in appointments" :key="appointment.id || `${appointment.date}-${appointment.start_time_service}`">
                          <td class="ps-0 fw-medium">{{ formatAppointmentDate(appointment) }}</td>
                          <td>{{ formatAppointmentTime(appointment) }}</td>
                          <td>{{ formatAppointmentService(appointment) }}</td>
                          <td>{{ formatAppointmentUser(appointment) }}</td>
                          <td class="pe-0">{{ formatAppointmentPrice(appointment) }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div class="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center mt-20 pb-20 gap-2">
                    <div class="fs-14 text-muted">
                      Página {{ appointmentsPagination.current_page }} de {{ appointmentsPagination.last_page }} —
                      Total de {{ appointmentsPagination.total }} agendamentos
                    </div>
                    <nav aria-label="Paginação de agendamentos do cliente">
                      <ul class="pagination mb-0">
                        <li class="page-item" :class="{ disabled: appointmentsPagination.current_page <= 1 || isLoadingAppointments }">
                          <button
                            type="button"
                            class="page-link"
                            :disabled="appointmentsPagination.current_page <= 1 || isLoadingAppointments"
                            @click="fetchAppointments(appointmentsPagination.current_page - 1)"
                          >
                            Anterior
                          </button>
                        </li>
                        <li class="page-item" :class="{ disabled: appointmentsPagination.current_page >= appointmentsPagination.last_page || isLoadingAppointments }">
                          <button
                            type="button"
                            class="page-link"
                            :disabled="appointmentsPagination.current_page >= appointmentsPagination.last_page || isLoadingAppointments"
                            @click="fetchAppointments(appointmentsPagination.current_page + 1)"
                          >
                            Próxima
                          </button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>

                <form v-else ref="formUpdateClient" @submit="updateClientMethod($event)">
                  <p>Preencha as informações abaixo para atualizar</p>
                  
                  <div class="mb-15 mb-mb-15 mb-md-20 col-12 mt-30">
                    <label for="name_client_update" class="form-label fw-medium">Nome</label>
                    <input
                      :value="getCurrentUpdateClient.name"
                      type="text"
                      class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                      id="name_client_update"
                      placeholder="Digite o nome"
                      autocomplete="off"
                      required
                    />
                  </div>

                  <div class="mb-15 mb-mb-15 mb-md-20 col-12 mt-30">
                    <label for="email_client_update" class="form-label fw-medium">Email</label>
                    <input
                      :value="getCurrentUpdateClient.email"
                      type="text"
                      class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                      id="email_client_update"
                      placeholder="Digite o email"
                      autocomplete="off"
                    />
                  </div>

                  <div class="mb-15 mb-mb-15 mb-md-20 col-12 mt-30">
                    <label for="cellphone_client_update" class="form-label fw-medium">Celular</label>
                    <input
                      :value="getCurrentUpdateClient.phone"
                      id="cellphone_client_update"
                      ref="cellphone_update"
                      type="text"
                      class="form-control shadow-none rounded-0 text-black radius-7"
                      placeholder="Digite o celular"
                      @keyup="changeInformationInputs('cellphone_update')"
                      @input="applyMaskPhone"
                      maxlength="15"
                      disabled
                    />
                  </div>

                  <div class="mb-15 mb-mb-15 mb-md-20 col-12 mt-30">
                    <label for="birthdate_client_update" class="form-label fw-medium">Data de nascimento (opcional)</label>
                    <input
                      :value="formattedBirthDate"
                      id="birthdate_client_update"
                      type="text"
                      class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                      placeholder="Digite a data ex: DD/MM/AAAA"
                      autocomplete="off"
                      maxlength="10"
                      @input="applyMaskDate"
                    />
                  </div>

                  <div class="col-12 pb-20">
                    <div id="alertResponseApiUpdateClient" class="toast align-items-center text-bg-success border-0 mt-4 w-100" role="alert" aria-live="assertive" aria-atomic="true">
                      <div class="d-flex">
                        <div class="toast-body fs-md-15 fs-lg-16" id="errorMessageUpdateClient">
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <div class="modal-footer">
                <button type="button" class="btn btn-danger update-client-modal" data-bs-dismiss="modal">
                  {{ activeTab === 'appointments' ? 'Fechar' : 'Cancelar' }}
                </button>
                <button v-if="activeTab === 'info'" type="button" ref="buttonUpdateClient" class="btn btn-success" @click="updateClientMethod($event)">
                  Salvar
                </button>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
import * as bootstrap from 'bootstrap';
import api from '../../config/axios.js';
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';
import CreateScheduleModal from '../../pages/Calendar/CreateScheduleModal.vue';

const DEFAULT_PAGINATION = {
  current_page: 1,
  last_page: 1,
  per_page: 10,
  total: 0,
};

export default {
  name: "UpdateClientModal",
  components: {
    CreateScheduleModal,
  },
  data() {
    return {
      activeTab: 'appointments',
      scheduleModalDate: moment().format('YYYY-MM-DD'),
      appointments: [],
      appointmentsPagination: { ...DEFAULT_PAGINATION },
      isLoadingAppointments: false,
      appointmentsEndpointResolver: null,
      lastFetchedClientPhone: '',
      updateClientModalInstance: null,
      createScheduleModalInstance: null,
    };
  },
  computed: {
    ...mapGetters([
      "getCurrentUpdateClient",
      "getCurrentUpdateClientTab",
    ]),
    formattedBirthDate() {
      const birthDate = this.getCurrentUpdateClient?.birth_date;
      if (!birthDate) {
        return "";
      }

      return moment(birthDate, 'YYYY-MM-DD').format('DD/MM/YYYY');
    }
  },
  watch: {
    'getCurrentUpdateClient.phone': {
      immediate: true,
      handler(newValue) {
        const normalizedPhone = String(newValue || '').replace(/\D/g, '');

        this.$nextTick(() => {
          if (!this.$refs.cellphone_update) {
            return;
          }

          this.applyMaskPhone({
            target: this.$refs.cellphone_update
          });
        });

        if (!normalizedPhone) {
          this.resetAppointmentsState();
          return;
        }

        this.activeTab = this.getCurrentUpdateClientTab || 'appointments';
        this.scheduleModalDate = moment().format('YYYY-MM-DD');
        this.appointmentsEndpointResolver = null;
        this.lastFetchedClientPhone = '';
      },
    },
  },
  mounted() {
    const updateClientModalEl = document.getElementById('UpdateClientModal');
    if (updateClientModalEl) {
      this.updateClientModalInstance = bootstrap.Modal.getOrCreateInstance(updateClientModalEl);
      updateClientModalEl.addEventListener('shown.bs.modal', this.handleShownUpdateClientModal);
      updateClientModalEl.addEventListener('hidden.bs.modal', this.handleHiddenUpdateClientModal);
    }

    const createScheduleModalEl = document.getElementById('createScheduleModal');
    if (createScheduleModalEl) {
      this.createScheduleModalInstance = bootstrap.Modal.getOrCreateInstance(createScheduleModalEl);
      createScheduleModalEl.addEventListener('shown.bs.modal', this.handleShownCreateScheduleModal);
      createScheduleModalEl.addEventListener('hidden.bs.modal', this.handleHiddenCreateScheduleModal);
    }
  },
  unmounted() {
    const updateClientModalEl = document.getElementById('UpdateClientModal');
    if (updateClientModalEl) {
      updateClientModalEl.removeEventListener('shown.bs.modal', this.handleShownUpdateClientModal);
      updateClientModalEl.removeEventListener('hidden.bs.modal', this.handleHiddenUpdateClientModal);
    }

    const createScheduleModalEl = document.getElementById('createScheduleModal');
    if (createScheduleModalEl) {
      createScheduleModalEl.removeEventListener('shown.bs.modal', this.handleShownCreateScheduleModal);
      createScheduleModalEl.removeEventListener('hidden.bs.modal', this.handleHiddenCreateScheduleModal);
    }

  },
  methods: {
    ...mapActions([
      'setCurrentUpdateClient',
      'setCurrentUpdateClientTab'
    ]),
    syncModalStacking() {
      const clientModalEl = document.getElementById('UpdateClientModal');
      const scheduleModalEl = document.getElementById('createScheduleModal');

      if (!clientModalEl || !scheduleModalEl) {
        return;
      }

      clientModalEl.classList.add('stacked-client-modal');
      const clientDialog = clientModalEl.querySelector('.modal-dialog');
      if (clientDialog) {
        clientDialog.classList.add('stacked-client-modal-dialog');
      }

      scheduleModalEl.classList.add('stacked-schedule-modal');
      const scheduleDialog = scheduleModalEl.querySelector('.modal-dialog');
      if (scheduleDialog) {
        scheduleDialog.classList.add('stacked-schedule-modal-dialog');
      }

      const backdrops = document.querySelectorAll('.modal-backdrop');
      if (backdrops.length >= 2) {
        backdrops[0].classList.add('stacked-client-backdrop');
        backdrops[1].classList.add('stacked-schedule-backdrop');
      } else if (backdrops.length === 1) {
        backdrops[0].classList.add('stacked-schedule-backdrop');
      }
    },
    clearModalStacking() {
      const clientModalEl = document.getElementById('UpdateClientModal');
      const scheduleModalEl = document.getElementById('createScheduleModal');

      clientModalEl?.classList.remove('stacked-client-modal');
      clientModalEl?.querySelector('.modal-dialog')?.classList.remove('stacked-client-modal-dialog');

      scheduleModalEl?.classList.remove('stacked-schedule-modal');
      scheduleModalEl?.querySelector('.modal-dialog')?.classList.remove('stacked-schedule-modal-dialog');

      document.querySelectorAll('.modal-backdrop').forEach((backdrop) => {
        backdrop.classList.remove('stacked-client-backdrop');
        backdrop.classList.remove('stacked-schedule-backdrop');
      });

      if (document.querySelector('#UpdateClientModal.show')) {
        document.body.classList.add('modal-open');
      }
    },
    resetAppointmentsState() {
      this.appointments = [];
      this.appointmentsPagination = { ...DEFAULT_PAGINATION };
      this.isLoadingAppointments = false;
      this.lastFetchedClientPhone = '';
    },
    handleHiddenUpdateClientModal() {
      this.activeTab = 'appointments';
      this.scheduleModalDate = moment().format('YYYY-MM-DD');
      this.appointmentsEndpointResolver = null;
      this.resetAppointmentsState();
      this.setCurrentUpdateClient({});
      this.setCurrentUpdateClientTab('appointments');
    },
    setActiveTab(tab) {
      this.activeTab = tab;

      if (tab === 'appointments' && String(this.getCurrentUpdateClient?.phone || '').replace(/\D/g, '')) {
        this.fetchAppointments(1);
      }
    },
    handleShownUpdateClientModal() {
      this.activeTab = this.getCurrentUpdateClientTab || 'appointments';

      const currentPhone = String(this.getCurrentUpdateClient?.phone || '').replace(/\D/g, '');

      if (
        this.activeTab === 'appointments' &&
        currentPhone &&
        this.lastFetchedClientPhone !== currentPhone
      ) {
        this.fetchAppointments(1);
      }
    },
    handleShownCreateScheduleModal() {
      setTimeout(() => {
        this.syncModalStacking();
      }, 10);
    },
    handleHiddenCreateScheduleModal() {
      this.clearModalStacking();

      if (document.querySelector('#UpdateClientModal.show')) {
        document.body.classList.add('modal-open');
      }
    },
    openCreateScheduleModal() {
      if (!this.getCurrentUpdateClient || !String(this.getCurrentUpdateClient?.phone || '').replace(/\D/g, '')) {
        return;
      }

      this.scheduleModalDate = moment().format('YYYY-MM-DD');

      const modalEl = document.getElementById('createScheduleModal');
      if (!modalEl) {
        return;
      }

      const modalInstance = bootstrap.Modal.getOrCreateInstance(modalEl);
      modalInstance.show();

      setTimeout(() => {
        this.syncModalStacking();
      }, 10);
    },
    buildAppointmentCandidates(page) {
      const clientPhone = String(this.getCurrentUpdateClient?.phone || '').replace(/\D/g, '');

      return [
        {
          key: 'calendar-list-client-phone',
          request: () => api.axios.get('/api/calendar/list/client', {
            params: {
              client_id: clientPhone,
              page,
            }
          })
        }
      ];
    },
    normalizeAppointmentResponse(payload, requestedPage) {
      const list = Array.isArray(payload?.data)
        ? payload.data
        : Array.isArray(payload)
          ? payload
          : Array.isArray(payload?.items)
            ? payload.items
            : [];

      return {
        data: list,
        pagination: {
          current_page: payload?.current_page || requestedPage,
          last_page: payload?.last_page || 1,
          per_page: payload?.per_page || list.length || DEFAULT_PAGINATION.per_page,
          total: payload?.total || list.length,
        }
      };
    },
    async fetchAppointments(page = 1) {
      if (!String(this.getCurrentUpdateClient?.phone || '').replace(/\D/g, '')) {
        this.resetAppointmentsState();
        return;
      }

      this.isLoadingAppointments = true;

      try {
        let response = null;

        if (this.appointmentsEndpointResolver) {
          response = await this.appointmentsEndpointResolver(page);
        } else {
          const candidates = this.buildAppointmentCandidates(page);

          for (const candidate of candidates) {
            try {
              response = await candidate.request();
              this.appointmentsEndpointResolver = (nextPage) => {
                const nextCandidates = this.buildAppointmentCandidates(nextPage);
                const matchedCandidate = nextCandidates.find(item => item.key === candidate.key);
                return matchedCandidate.request();
              };
              break;
            } catch (error) {
              if (error?.response?.status && ![400, 404, 405, 422].includes(error.response.status)) {
                throw error;
              }
            }
          }
        }

        if (!response || !response.data) {
          this.appointments = [];
          this.appointmentsPagination = { ...DEFAULT_PAGINATION, current_page: page };
          return;
        }

        const normalized = this.normalizeAppointmentResponse(response.data, page);
        this.appointments = normalized.data;
        this.appointmentsPagination = normalized.pagination;
        this.lastFetchedClientPhone = String(this.getCurrentUpdateClient?.phone || '').replace(/\D/g, '');
      } catch (error) {
        console.error('Erro ao buscar agendamentos do cliente:', error);
        this.appointments = [];
        this.appointmentsPagination = { ...DEFAULT_PAGINATION, current_page: page };
      } finally {
        this.isLoadingAppointments = false;
      }
    },
    formatAppointmentDate(appointment) {
      const date = appointment?.date || appointment?.start_date || appointment?.start;
      if (!date) {
        return '-';
      }

      const parsedDate = moment(date, ['YYYY-MM-DD', moment.ISO_8601]);
      if (!parsedDate.isValid()) {
        return '-';
      }

      const weekDay = parsedDate.format('dddd');
      return `${parsedDate.format('DD/MM/YYYY')} (${weekDay.charAt(0).toUpperCase()}${weekDay.slice(1)})`;
    },
    formatAppointmentTime(appointment) {
      const start = appointment?.start_time_service || appointment?.start_time || appointment?.selected_time;
      const end = appointment?.end_time_service || appointment?.end_time;

      if (start && end) {
        return `${String(start).slice(0, 5)} - ${String(end).slice(0, 5)}`;
      }

      if (start) {
        return String(start).slice(0, 5);
      }

      return '-';
    },
    formatAppointmentService(appointment) {
      return appointment?.service?.name || appointment?.service_name || appointment?.title || 'Sem serviço';
    },
    formatAppointmentUser(appointment) {
      return appointment?.user?.name || appointment?.attendant?.name || appointment?.user_name || 'Sem atendente';
    },
    formatAppointmentPrice(appointment) {
      const price = appointment?.base_price_formatted;
      if (!price) {
        return 'Não informado';
      }

      return String(price).trim().startsWith('R$') ? price : `R$ ${price}`;
    },
    changeInformationInputs(element){
      this.$refs[element].style.borderColor = "#dedee4";
    },
    applyMaskPhone(event) {
      const input = event.target;
      if (!input) {
        return;
      }

      let value = input.value.replace(/\D/g, '');

      if (value.length > 10) {
        value = value.replace(/^(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
      } else {
        value = value.replace(/^(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
      }

      input.value = value;
    },
    applyMaskDate(event) {
      const input = event.target;
      let value = input.value.replace(/\D/g, '').slice(0, 8);

      if (value.length > 2) {
        value = `${value.slice(0, 2)}/${value.slice(2)}`;
      }
      if (value.length > 5) {
        value = `${value.slice(0, 5)}/${value.slice(5)}`;
      }

      input.value = value;
    },
    updateClientMethod(event){
      if (event) {
        event.preventDefault();
      }
      const alertResponse = this.alertResponse;

      const client_id = this.getCurrentUpdateClient.id;
      const name_client_update = document.getElementById("name_client_update").value;
      const email_client_update = document.getElementById("email_client_update").value;
      const cellphone_client_update = document.getElementById("cellphone_client_update").value;
      const birthdate_client_update = document.getElementById("birthdate_client_update").value;
      
      if(!name_client_update){
        this.alertResponse("Por favor preencha todos os campos", true);
        return;
      }

      const objClientUpdate = {
        "id": client_id,
        "name": name_client_update,
        "email": email_client_update,
        "phone": cellphone_client_update.replace(/\D/g, ''),
      }
      if(birthdate_client_update && birthdate_client_update.trim() !== ""){
        objClientUpdate.birth_date = birthdate_client_update;
      }

      const buttonUpdateClient = this.$refs.buttonUpdateClient;
      buttonUpdateClient.disabled = true;
      buttonUpdateClient.innerHTML = "Salvando...";
      
      if (birthdate_client_update && birthdate_client_update.length < 10) {
        this.alertResponse("Data de nascimento incompleta.", true);
        buttonUpdateClient.disabled = false;
        buttonUpdateClient.innerHTML = "Salvar";
        return;
      }

      api.axios.post("/api/update/client", objClientUpdate).catch(function(error){
        if(error.response.data != undefined){
          buttonUpdateClient.innerHTML = "Salvar";
        }
        console.log("error", error);
        alertResponse(error.response.data, true);
      }).then(function(response){
        
        if(response != undefined && response.status == 200){
          buttonUpdateClient.innerHTML = "Informações salvas com sucesso !";
          window.location.reload();
        } else {
          buttonUpdateClient.disabled = false;
          buttonUpdateClient.innerHTML = "Salvar";
        }
      });
    },
    alertResponse(message, error){
      const warningMessage = `<i class="flaticon flaticon-warning"></i> `+message;
      const successMessage = `<i class="flaticon flaticon-check"></i> `+message;
      
      if(error){
        document.getElementById("errorMessageUpdateClient").innerHTML = warningMessage;
      } else {
        document.getElementById("errorMessageUpdateClient").innerHTML = successMessage;
      }

      const elementAlert = document.getElementById("alertResponseApiUpdateClient");
      if(elementAlert){
        if(error){
          elementAlert.classList.add('bkred');
        } else {
          elementAlert.classList.remove('bkred');
        }
        elementAlert.style.display = "block";
        setTimeout(() => {
          elementAlert.style.display = "none";
        }, 7000);
      }
    },
  }
};
</script>

<style scoped>
:deep(.stacked-client-modal) {
  z-index: 1055 !important;
}

:deep(.stacked-client-modal-dialog) {
  position: relative !important;
  z-index: 1056 !important;
}

:deep(.stacked-schedule-modal) {
  z-index: 1080 !important;
}

:deep(.stacked-schedule-modal-dialog) {
  position: relative !important;
  z-index: 1081 !important;
}

:deep(.modal-backdrop.stacked-client-backdrop) {
  z-index: 1050 !important;
}

:deep(.modal-backdrop.stacked-schedule-backdrop) {
  z-index: 1075 !important;
}

.appointments-history-table {
  min-width: 640px;
}

.appointments-history-table th,
.appointments-history-table td:not([colspan]) {
  white-space: nowrap;
}

.appointments-history-table-wrap {
  scrollbar-width: thin;
}

@media (max-width: 767px) {
  .nav-tabs {
    flex-wrap: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: thin;
  }

  .nav-tabs .nav-item {
    flex: 0 0 auto;
  }

  .nav-tabs .nav-link {
    white-space: nowrap;
  }
}
</style>
